import React from "react";

import Button from "../Button/Button";
import searchbar from "../SearchBar/searchbar.module.css";

const DoctorsNearby = (props) => {
  const { ZipCode, City, State, Doctor, Speciality, Address } = props.doctor;
  return (
    <>
      {ZipCode && (
        <div className={searchbar.details}>
          <li>{ZipCode},</li>
          <li>{City},</li>
          <li>{State}</li>
        </div>
      )}
      <div className={searchbar.docaddress}>
        <li>{Doctor}</li>
        <li>{Speciality}</li>
        <li>{Address}</li>
      </div>
      <Button
        buttonName="Select This Doctor"
        onClick={() => props.selectDoctor(props.doctor)}
        style={{
          fontSize: "16px",
          backgroundColor: "#091135bd",
          color: "white",
          width: "80%",
          maxWidth: "250px",
          height: "35px",
          marginTop: "10px",
          display: props && props.selectDoctor ? "block" : "none",
        }}
      />
    </>
  );
};

export default DoctorsNearby;
